import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=472052a7"
import script from "./DescriptionCard.vue?vue&type=script&lang=js"
export * from "./DescriptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports